import { Link } from "react-router-dom";
import Spinner from "./Spinners/inlineSpinner";

const Button = ({onClick, buttonText, buttonRole, destination, icon, otherStyles, loading}) => {
    return ( 
        <div className="">
            { buttonRole === "link" ?
            <Link to={destination} className={`${otherStyles} text-sm font-medium py-6 px-8 md:p-4 rounded flex items-center justify-between`}>
              {buttonText}
              <img src={icon} alt="" className={`h-4 ${icon ? 'ps-4' : ''}`}/>
            </Link>
            : buttonRole === "externalLink" ?
            <a href={destination} target="_blank" rel="noreferrer" className={`${otherStyles} text-sm font-medium py-6 px-8 md:p-4 rounded w-fit flex items-center justify-between`}>
              {buttonText}
              <img src={icon} alt="" className={`h-4 ${icon ? 'ps-4' : ''}`}/> 
            </a>
            : buttonRole === "custom" ?
            <div onClick={onClick} className={`${otherStyles} cursor-pointer text-sm font-medium py-6 px-8 md:p-4 rounded flex items-center justify-center`}> 
              {buttonText}
              <img src={icon} alt="" className={`h-4 ${icon ? 'ps-4' : ''}`}/>
            </div>
            :
            <button type="submit" disabled={loading} className={`${otherStyles} text-sm font-medium py-6 px-8 md:p-4 rounded flex items-center justify-between`}> 
              {loading ? 
              <div className="flex items-end">
                <Spinner />
              </div>
              : 
              <div className="flex items-end justify-between w-full">
                <span>{buttonText}</span>
                <img src={icon} alt="" className={`h-5 ${icon ? 'ps-4' : ''}`}/>
              </div>
              }
            </button>
            }
        </div>
     );
}
 
export default Button;